module.exports = __webpack_public_path__ + "img/middle_11.1dc8b1f9.png";